import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { declineFriendRequest } from "../../../actions/friend";
import { declineCasualFriendRequest } from "../../../actions/notification";

const DeclineCasualRequest = ({
  match,
  declineFriendRequest,
  declineCasualFriendRequest,
  setdeclineemployercasualrequest,
  profile: { user, avatar, firstname, lastname, companyname, location },
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            className="fas fa-times fa-3x message-x"
            onClick={() =>
              setdeclineemployercasualrequest({
                request: false,
                confirm: false,
              })
            }
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">{companyname}</span>
                </li>
                <li className="user-online-item">
                  {firstname} {lastname}
                </li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text">
            Would you like to decline the friend request from{" "}
            <span className="blue bold">
              {firstname} {lastname}
            </span>{" "}
            of <span className="blue bold">{companyname}</span>?
          </div>
          <div className="flex-center">
            <button
              className="user-request-button background-blue"
              onClick={() =>
                declineFriendRequest({ user }) &&
                declineCasualFriendRequest(match.params.channelid) &&
                setdeclineemployercasualrequest({
                  request: false,
                  confirm: true,
                })
              }
            >
              <i className="far fa-check-circle fa-sm mr-5"></i>
              Confirm
            </button>
            <button
              className="user-request-button background-blue"
              onClick={() =>
                setdeclineemployercasualrequest({
                  request: false,
                  confirm: false,
                })
              }
            >
              <i className="fas fa-times fa-sm mr-5 bold"></i>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

DeclineCasualRequest.propTypes = {
  auth: PropTypes.object.isRequired,
  declineFriendRequest: PropTypes.func.isRequired,
  declineCasualFriendRequest: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  friend: state.friend,
});

export default connect(mapStateToProps, {
  declineFriendRequest,
  declineCasualFriendRequest,
})(DeclineCasualRequest);
